/**
 * The steps a scenario is made of, in flow order.
 *
 * PLANNING_SIMPLIFIED reduces planning to one linear pass. The two lists are
 * shared by the shell (which builds the nav from them) and the detail route
 * (which enforces them, so a bookmark or the back stack cannot reach a step the
 * flow no longer has).
 */
export const PLANNING_TABS = [
  "home",
  "scenarios",
  "shortlist",
  "sites",
  "siteplan",
  "milestones",
  "enrollment",
  "vendors",
  "budget",
] as const;

export const SIMPLIFIED_PLANNING_TABS = [
  "shortlist",
  "sites",
  "enrollment",
] as const;

/** Where a simplified scenario opens, and where a removed step redirects to. */
export const SIMPLIFIED_ENTRY_STEP = SIMPLIFIED_PLANNING_TABS[0];

/**
 * Ask Vivo is registered under the same parent but is not a step — it is the
 * assistant, reachable from anywhere — so simplification does not remove it.
 */
const NON_STEP_ROUTES = ["askvivo"];

export function isReachablePlanningStep(
  step: string,
  simplified: boolean,
): boolean {
  if (!simplified) return true;
  return (
    NON_STEP_ROUTES.includes(step) ||
    (SIMPLIFIED_PLANNING_TABS as readonly string[]).includes(step)
  );
}
